<template>
  <div id="app-wrap">
    <section id="main-cta">
      <div class="section-inner">
        <h1 class="title">TunnelBear for Windows</h1>
        <img-set
          classes="main-img"
          :webpSrc="require('@/views/app-windows/images/apps_1_pc.webp')"
          :webpSrc2x="require('@/views/app-windows/images/apps_1_pc@2x.webp')"
          :imgSrc="require('@/views/app-windows/images/apps_1_pc.png')"
          :imgSrc2x="require('@/views/app-windows/images/apps_1_pc@2x.png')"
          alt="TunnelBear for Windows"/>
        <p>Simple, secure and handsome.  It's time to put a Bear in your computer and start protecting your browsing and&nbsp;location.</p>
        <router-link class="btn btn-lg" :to="{name: 'checkout'}">Get TunnelBear</router-link>
      </div>
    </section>
    <features>
      <template slot="content">
        <div class="feature-wrap">
          <div class="feature-icon"></div>
          <div class="desc">
            <h6 class="header">Simple and Handsome</h6>
            <p>On/off simplicity paired with a handsome map to visualize your connection. An app so thoughtfully designed, a bear could use&nbsp;it.</p>
          </div>
        </div>

        <div class="feature-wrap">
          <div class="feature-icon"></div>
          <div class="desc">
            <h6 class="header">VigilantBear</h6>
            <p>Don't worry if you lose your Wi-Fi connection, TunnelBear has your back.  It will block all unsecured traffic until everything has safely&nbsp;reconnected.</p>
          </div>
        </div>

        <div class="feature-wrap">
          <div class="feature-icon"></div>
          <div class="desc">
            <h6 class="header">Strong Encryption</h6>
            <p>TunnelBear uses strong AES 256-bit encryption by&nbsp;default. Weaker encryption isn't even an option.</p>
          </div>
        </div>

        <div class="feature-wrap">
          <div class="feature-icon"></div>
          <div class="desc">
            <h6 class="header">GhostBear</h6>
            <p>Is your VPN blocked in some countries? With GhostBear, you can make your VPN-encrypted data less detectable to governments, businesses and ISPs.</p>
          </div>
        </div>

      </template>
      <template slot="img">
        <img-set
          lazyload
          :webpSrc="require('@/views/app-windows/images/apps_2_pc.webp')"
          :webpSrc2x="require('@/views/app-windows/images/apps_2_pc@2x.webp')"
          :imgSrc="require('@/views/app-windows/images/apps_2_pc.png')"
          :imgSrc2x="require('@/views/app-windows/images/apps_2_pc@2x.png')"
          alt="TunnelBear for Windows" :width="659" :height="470"/>
      </template>
    </features>
    <audit-section></audit-section>
    <country-access bg="bg-alt">
      <template slot="copy">
        <h2 class="h3">One-click access to {{ tunnels.length }} countries</h2>
        <p>With unlimited bandwidth and server switches, TunnelBear lets you browse from {{ tunnels.length }} countries in its ever expanding network.</p>
      </template>
    </country-access>
    <why-tunnelbear></why-tunnelbear>
    <download>
      <template slot="image">
        <img-set
          lazyload
          :webpSrc="require('@/images/apps/apps_footerbear.webp')"
          :webpSrc2x="require('@/images/apps/apps_footerbear@2x.webp')"
          :imgSrc="require('@/images/apps/apps_footerbear.png')"
          :imgSrc2x="require('@/images/apps/apps_footerbear@2x.png')"
          :width="440" :height="640"/>
      </template>
    </download>
  </div>
</template>

<script>
import countryAccess from '@/components/country-access/country-access'
import features from '@/components/features/features'
import audit from '@/components/audit/audit'
import whyTunnelbear from '@/components/why-tunnelbear/why-tunnelbear'
import download from '@/components/download-cta/download-cta'

export default {
  name: 'windows',
  data () {
    return {}
  },
  components: {
    'audit-section': audit,
    'country-access': countryAccess,
    'why-tunnelbear': whyTunnelbear,
    download,
    features
  }
}
</script>

<style scoped lang="stylus" src="./app-windows.styl" >
